import { render } from "./TheFooter.vue?vue&type=template&id=cbe3b6a0&scoped=true&ts=true"
import script from "./TheFooter.vue?vue&type=script&lang=ts"
export * from "./TheFooter.vue?vue&type=script&lang=ts"

import "./TheFooter.vue?vue&type=style&index=0&id=cbe3b6a0&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cbe3b6a0"]])

export default __exports__